import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/org/$orgId/test-project')({
  component: TestProjectPage,
});

function TestProjectPage() {
  const { orgId } = Route.useParams();
  
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-red-600">
        🧪 TEST PROJECT PAGE
      </h1>
      <p className="text-gray-600 mt-2">
        Organization ID: {orgId}
      </p>
      <p className="text-green-600 mt-4">
        ✅ Si ves esta página, las rutas básicas funcionan correctamente.
      </p>
      <p className="text-blue-600 mt-2">
        📍 URL: /org/{orgId}/test-project
      </p>
    </div>
  );
}
